/**
 * 创建 AbortController。旧版 CEF / Edge 内核没有该 Web API 时回退到 shim。
 * 需配合 abortcontroller-polyfill 才能让原生 fetch 真正响应 abort。
 */
import "abortcontroller-polyfill/dist/polyfill-patch-fetch";

function createShimAbortController() {
  let aborted = false;
  const listeners = [];

  const signal = {
    get aborted() {
      return aborted;
    },
    addEventListener(type, listener) {
      if (type === "abort" && typeof listener === "function") {
        listeners.push(listener);
      }
    },
    removeEventListener(type, listener) {
      if (type !== "abort") {
        return;
      }
      const index = listeners.indexOf(listener);
      if (index !== -1) {
        listeners.splice(index, 1);
      }
    },
  };

  return {
    signal,
    abort() {
      if (aborted) {
        return;
      }
      aborted = true;
      listeners.slice().forEach((listener) => {
        listener();
      });
    },
  };
}

export function createAbortController() {
  if (typeof AbortController === "function") {
    return new AbortController();
  }
  return createShimAbortController();
}
